export const styles = {
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
  },
  tableWrapper: {
    overflowY: 'scroll',
    height: 'calc(100vh - 55px)',
  },
  table: {
    minWidth: 750,
    borderCollapse: 'separate !important',
  },
  row: {
    backgroundColor: '#F8F8F8',
  },
  endedSequence: {
    opacity: 0.4,
  },
  highLight: {
    backgroundColor: 'rgba(255, 206, 5, 0.2)',
  },
  highlightHardcodedComms: {
    backgroundColor: '#FEEFF1',
  },
  tableRow: {
    height: '61px',
  },
  highlightExpandedRow: {
    backgroundColor: '#F9F9FF',
  },
  noDataWrapper: {
    height: 'calc(100vh - 400px)',
  },
  disableBorderBottom: {
    borderBottom: '0px',
  },
  delayColumn: {
    width: '45%',
  },
  wrapper: {
    display: 'flex',
    border: '1px solid #8A96A0',
    margin: '44px',
    padding: '20px',
    borderRadius: '15px',
    justifyContent: 'center',
  },
  insideBlock: {
    display: 'flex',
    width: '100px',
    justifyContent: ' space-between',
    alignItems: 'center',
    color: '#8A96A0',
  },
  hover: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}
